// import axios from "../helpers/api";
import axios from "axios";
import { API_BASE_URL } from "../stories/Constant";

export const userServices = {
  login,
  logout,
  register,
  verifyUserOTP,
  resetPassword,
  forgotPassword,
  addtoCart,
  changePassword,
  tfaSetup,
  tfaVerifySetup,
  tfaDisable,
  tfaVerifyLogin,
  tfaRegenerateBackupCodes,
};

// @method -  POST
// @Descr - User register and recieve OTP for verification on request
//@Route - /user/signup
async function register(payload) {
  return (
    axios
      .post(`${API_BASE_URL}/user/signup`, payload)
      // .then(handleAuthResponse)
      .then((user) => {
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("isLoggedIn", false);
        return user;
      })
      .catch((err) => {
        throw err;
      })
  );
}

// @method -  POST
// @Descr - User input the recived OTP and verify thier account
//@Route - /user/signup_verify_otp

async function verifyUserOTP(payload) {
  let { otp } = payload;
  return (
    axios
      .post(`${API_BASE_URL}/user/signup_verify_otp`, payload)
      // .then(handleAuthResponse)
      .then((recievedOtp) => {
        if (otp !== recievedOtp) {
          // OTP mismatch
        }
      })
      .catch((err) => {
        throw err;
      })
  );
}

// @method -  POST
// @Descr - Verified User can access the page and log in
//@Route - /user/signin
async function login(payload) {
  // Include anonymous cart token so backend can merge carts on login
  const anonymousCartToken = localStorage.getItem("anonymous_cart_token");
  if (anonymousCartToken) {
    payload.anonymous_cart_token = anonymousCartToken;
  }
  return axios
    .post(`${API_BASE_URL}/user/signin`, payload)
    .then((response) => {
      const data = response.data;
      // If 2FA is required, return the temp token without storing JWT
      if (data.status === true && data.requires_2fa) {
        return { requires_2fa: true, temp_token: data.temp_token };
      }
      return handleAuthResponse(response);
    })
    .then((user) => {
      // If 2FA is required, don't set localStorage yet
      if (user.requires_2fa) {
        return user;
      }
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("isLoggedIn", true);
      // Clear anonymous cart token after successful merge
      localStorage.removeItem("anonymous_cart_token");
      // Apply pending referral code if stored from registration
      applyPendingReferralCode(user.jwt_token);
      return user;
    })
    .catch((e) => {
      throw e;
    });
}

// Apply pending referral code after first login
async function applyPendingReferralCode(token) {
  const referralCode = localStorage.getItem("pending_referral_code");
  if (referralCode && token) {
    try {
      await axios.post(
        `${API_BASE_URL}/user/referral/apply/`,
        { referral_code: referralCode },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      // Silently fail - referral is a bonus, not critical
      console.log("Referral code application failed:", err?.response?.data?.message || err.message);
    } finally {
      localStorage.removeItem("pending_referral_code");
    }
  }
}

// @method - POST
// @Descr - Verify TOTP code during login (2FA step)
//@Route - /auth/2fa/verify/
async function tfaVerifyLogin(payload) {
  return axios
    .post(`${API_BASE_URL}/auth/2fa/verify/`, payload)
    .then(handleAuthResponse)
    .then((user) => {
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("isLoggedIn", true);
      localStorage.removeItem("anonymous_cart_token");
      return user;
    })
    .catch((e) => {
      throw e;
    });
}

// @method - POST
// @Descr - Begin 2FA setup (generate secret + QR code)
//@Route - /auth/2fa/setup/
async function tfaSetup() {
  const token = localStorage.getItem("token");
  return axios
    .post(`${API_BASE_URL}/auth/2fa/setup/`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => response.data)
    .catch((e) => { throw e.response?.data || e; });
}

// @method - POST
// @Descr - Verify initial TOTP code to confirm 2FA setup
//@Route - /auth/2fa/verify-setup/
async function tfaVerifySetup(code) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${API_BASE_URL}/auth/2fa/verify-setup/`, { code }, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => response.data)
    .catch((e) => { throw e.response?.data || e; });
}

// @method - POST
// @Descr - Disable 2FA
//@Route - /auth/2fa/disable/
async function tfaDisable(code) {
  const token = localStorage.getItem("token");
  return axios
    .post(`${API_BASE_URL}/auth/2fa/disable/`, { code }, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => response.data)
    .catch((e) => { throw e.response?.data || e; });
}

// @method - GET
// @Descr - Regenerate backup codes
//@Route - /auth/2fa/backup-codes/
async function tfaRegenerateBackupCodes() {
  const token = localStorage.getItem("token");
  return axios
    .get(`${API_BASE_URL}/auth/2fa/backup-codes/`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => response.data)
    .catch((e) => { throw e.response?.data || e; });
}

// @method -  POST
// @Descr -Clear all localstorage
//@Route - /logout
function logout() {
  localStorage.clear();
}

// @method -  POST
// @Descr -User forgot password,and could get a reset password OTP
//@Route - /forgot_password/send_reset_token
async function forgotPassword(payload) {
  localStorage.setItem("email", payload.email);
  return axios
    .post(`${API_BASE_URL}/forgot_password/send_reset_token`, payload)
    .then(handleAuthResponse)
    .then((msg) => {
      return msg;
    });
}

// @method -  POST
// @Descr -After OTP has been verified,user can reset their password
//@Route - /forgot_password/reset_password
async function resetPassword(payload) {
  axios
    .post(`${API_BASE_URL}/forgot_password/reset_password`, payload)
    .then(handleAuthResponse)
    .then((msg) => {
      // password reset handled
    });
}
// @method -  POST
// @Descr - Authenticated user changes their password
//@Route - /change_password
async function changePassword(payload) {
  return axios
    .post(`${API_BASE_URL}/change_password`, payload)
    .then(handleAuthResponse)
    .then((msg) => {
      return msg;
    });
}

// @method -  POST
// @Descr -Adding item to cart
//@Route -/orders/cart/add_to_cart
async function addtoCart(payload) {
  const { cart_token, amount, variant } = payload;
  axios
    .post(`${API_BASE_URL}/orders/cart/add_to_cart`, {
      cart_token,
      variant,
      quantity: amount,
    })
    .then(handleAuthResponse)
    .then((item) => {
      return item;
    })
    .catch((err) => {
      throw err;
    });
}

/*****UTILS Functions */

function handleAuthResponse(response) {
  let data;
  let status = response.data.status;
  try {
    if (status === true) {
      data = response.data;
      localStorage.setItem("token", data.jwt_token);
      return data;
    }

    if (status === false) {
      const err = {
        error: response.data.message || response.data.errors.email[0],
      };
      throw err.error;
    }
  } catch (error) {
    throw error;
  }
}
